<template>
  <div class="kit-piece-color-picker">
    <app-i18n
      class="kit-piece-color-picker__label"
      :code="code"
    />
    <div class="kit-piece-color-picker__wrapper">
      <el-select
        v-model="model.color1"
        ref="color1"
        :disabled="!type"
        size="mini"
        class="kit-piece-color-picker__picker"
        @change="updateColor(model.color1, 'color1')"
      >
        <el-option
          v-for="(option, i) in colors"
          :key="i"
          :label="option.color"
          :value="option.name"
          :style="{background: option.color, color: option.color}"
        >
        </el-option>
      </el-select>
      <el-select
        v-if="hasColor2"
        v-model="model.color2"
        ref="color2"
        :disabled="!type || !model.color1"
        size="mini"
        class="kit-piece-color-picker__picker"
        @change="updateColor(model.color2, 'color2')"
      >
        <el-option
          v-for="(option, i) in colors"
          :key="i"
          :label="option.color"
          :value="option.name"
          :style="{background: option.color, color: option.color}"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import colorMixin from '@/mixins/color'

export default {
  name: 'appKitPieceColorPicker',
  props: {
    code: String,
    value: Object,
    piece: {
      type: String,
      default: 'jersey',
      validator: v => ['jersey', 'pants'].includes(v),
    },
    type: {
      type: String,
    }
  },
  mixins: [colorMixin],
  data() {
    return {
      model: {},
    }
  },
  computed: {
    hasColor2() {
      if (!this.type || this.type === 'solid') return false
      return this.piece !== 'pants'
    },
    watchedValue: function() {
      // https://github.com/vuejs/vue/issues/2164
      return JSON.stringify(this.value)
    }
  },
  watch: {
    watchedValue: {
      handler(val, oldVal) {
        if (val === oldVal) return

        val = JSON.parse(val)

        this.model = {
          ...(this.piece === 'jersey' && { type: val.type }),
          color1: val.color1 || null,
          ...(this.hasColor2 && val.type !== 'solid' && ({ color2: val.color2 || null })),
        }
      },
      deep: true,
      immediate: true,
    },
    model: {
      async handler(val) {
        const reorderColors = this.hasColor2 && !!this.type && this.type !== 'solid' && !val.color1 && !!val.color2
        await this.$nextTick()

        const model = reorderColors
          ? {
            ...(this.piece === 'jersey' && { type: val.type }),
            color1: val.color2,
            color2: null,
          }
          : val

        if (reorderColors) this.model = model

        this.$emit('input', this.model)
      },
      deep: true,
      immediate: true,
    },
    type: {
      handler(val) {
        if (!val) this.updateColor('blanco', 'color1')
      }
    }
  },
  methods: {
    updateColor(name, ref) {
      const color = this.colors.find(col => col.name === name).color
      const selectedInput = this.$refs[ref].$el.querySelectorAll(
        ".el-input--suffix .el-input__inner"
      )[0]
      selectedInput.setAttribute('style', `background-color: ${color} !important;`)
    }
  }
}
</script>

<style lang="scss" scoped>
.kit-piece-color-picker {
  display: flex;
  align-items: space-between;

  &__wrapper {
    width: 50%;
    height: 50px;
    display: flex;
    flex-direction: row;

    ::v-deep .el-input__inner {
      width: 36px;
    }

    ::v-deep .el-input__suffix {
      display: none;
    }
  }

  &__label {
    width: 50%;
    height: 50px;
    font-size: 12px;
    font-weight: normal;
    text-align: right;
  }

  &__picker {
    @include desktop {
      margin-left: 16px;
    }
  }
}
</style>
